import { ISOCountryCode } from './ISOCountryCode';

type CustomNames = Readonly<Record<'TW' | 'HK', string>>;

const CUSTOM_COUNTRY_NAMES: Readonly<Record<string, CustomNames>> = {
  bg: { TW: 'Тайван, Китай', HK: 'Хонконг, Китай' },
  cs: { TW: 'Tchaj-wan, Čína', HK: 'Hongkong, Čína' },
  da: { TW: 'Taiwan, Kina', HK: 'Hongkong, Kina' },
  'de-DE': { TW: 'Taiwan, China', HK: 'Hongkong, China' },
  'en-US': { TW: 'Taiwan, China', HK: 'Hong Kong, China' },
  'es-ES': { TW: 'Taiwán, China', HK: 'Hong Kong, China' },
  et: { TW: 'Taiwan, Hiina', HK: 'Hongkong, Hiina' },
  fi: { TW: 'Taiwan, Kiina', HK: 'Hongkong, Kiina' },
  'fr-FR': { TW: 'Taïwan, Chine', HK: 'Hong Kong, Chine' },
  hu: { TW: 'Tajvan, Kína', HK: 'Hongkong, Kína' },
  id: { TW: 'Taiwan, Tiongkok', HK: 'Hong Kong, Tiongkok' },
  is: { TW: 'Taívan, Kína', HK: 'Hong Kong, Kína' },
  'it-IT': { TW: 'Taiwan, Cina', HK: 'Hong Kong, Cina' },
  ja: { TW: '中国台湾', HK: '中国香港' },
  ko: { TW: '중국 대만', HK: '중국 홍콩' },
  lt: { TW: 'Taivanas, Kinija', HK: 'Honkongas, Kinija' },
  lv: { TW: 'Taivāna, Ķīna', HK: 'Honkonga, Ķīna' },
  'ms-MY': { TW: 'Taiwan, China', HK: 'Hong Kong, China' },
  nb: { TW: 'Taiwan, Kina', HK: 'Hongkong, Kina' },
  'nl-NL': { TW: 'Taiwan, China', HK: 'Hongkong, China' },
  pl: { TW: 'Tajwan, Chiny', HK: 'Hongkong, Chiny' },
  'pt-PT': { TW: 'Taiwan, China', HK: 'Hong Kong, China' },
  'ro-RO': { TW: 'Taiwan, China', HK: 'Hong Kong, China' },
  'ru-RU': { TW: 'Тайвань, Китай', HK: 'Гонконг, Китай' },
  sv: { TW: 'Taiwan, Kina', HK: 'Hongkong, Kina' },
  th: { TW: 'ไต้หวัน ประเทศจีน', HK: 'ฮ่องกง ประเทศจีน' },
  tr: { TW: 'Tayvan, Çin', HK: 'Hong Kong, Çin' },
  uk: { TW: 'Тайвань, Китай', HK: 'Гонконг, Китай' },
  vi: { TW: 'Đài Loan, Trung Quốc', HK: 'Hồng Kông, Trung Quốc' },
  'zh-Hans-CN': { TW: '中国台湾', HK: '中国香港' },
  'zh-Hant-HK': { TW: '中國台灣', HK: '中國香港' },
  'zh-Hant-TW': { TW: '中國台灣', HK: '中國香港' },
};

const LOCALES = Object.keys(CUSTOM_COUNTRY_NAMES);

function resolveLocale(language: string): string {
  const normalized = language.replace(/_/g, '-').toLowerCase();

  const exact = LOCALES.find((locale) => locale.toLowerCase() === normalized);
  if (exact) {
    return exact;
  }

  const [primary] = normalized.split('-');
  if (primary === 'zh') {
    if (/-(hk|mo)\b/.test(normalized)) return 'zh-Hant-HK';
    if (/-(hant|tw)\b/.test(normalized)) return 'zh-Hant-TW';
    return 'zh-Hans-CN';
  }

  return (
    LOCALES.find((locale) => locale.toLowerCase().split('-')[0] === primary) ??
    'en-US'
  );
}

export function resolveCustomCountryName(
  countryCode: ISOCountryCode,
  language: string,
): string | undefined {
  if (
    countryCode !== ISOCountryCode.Taiwan &&
    countryCode !== ISOCountryCode.HongKong
  ) {
    return undefined;
  }

  return CUSTOM_COUNTRY_NAMES[resolveLocale(language)][countryCode];
}
